import {useState, useEffect} from 'react'
import axios from 'axios'
import {defaultpropsalertform} from 'entries/alertform'
import {ProgressFullScreen} from 'molecules'
import AlertForm from 'template/Form/AlertForm'
import QueryString from 'qs'
import {VmView} from 'components'

export default function Index({
  fields,
  apiEndpoint,
  onSubmit = () => {},
  onSuccess = () => {},
  onCancel = () => {},
  initialData = {},
  label = '',
  successLabel = 'Berhasil Menyimpan data',
  errorLabel = 'Terjadi kesalahan saat menyimpan data',
  apiParams = {},
  onChange,
  renderInput,
}) {
  const [form, setForm] = useState(initialData || {})
  const [loading, setLoading] = useState(false)
  const [propsalertform, setpropsalertform] = useState(defaultpropsalertform)

  useEffect(() => {
    if (!!initialData) setForm(initialData)
  }, [])

  const closeAlert = () => setpropsalertform(defaultpropsalertform)
  const openAlert = (caption, type, onConfirm = closeAlert) => {
    setpropsalertform({
      ...propsalertform,
      type,
      visible: true,
      children: <>{caption}</>,
      onConfirm: onConfirm,
      onClose: closeAlert,
      onCancel: closeAlert,
    })
  }

  const handleChange = e => {
    const updatedForm = {...form, [e.target.name]: e.target.value}
    setForm(updatedForm)
    if (onChange) {
      onChange(e, updatedForm)
    }
  }

  const handleSubmit = async () => {
    setLoading(true)

    const emptyField = fields.map(item => {
      if (item.required && !form[item.name]) {
        return item.label
      }
      return false
    })

    if (!!emptyField[0]) {
      setLoading(false)
      return openAlert(`Kolom ${emptyField[0]} wajib diisi`, 3)
    }

    const onSubmitData = onSubmit(form)
    if (!!onSubmitData?.additionalValidation) {
      return openAlert(onSubmitData.additionalValidation, 3)
    }

    try {
      const {data} = await axios.post(
        apiEndpoint,
        QueryString.stringify({...form, ...apiParams}),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      )

      if (data.status !== 1) {
        openAlert(data?.message || errorLabel, 3)
      } else {
        openAlert(data?.message || successLabel, 1, () => onSuccess(form))
      }
    } catch (err) {
      openAlert('[EC-8] ' + errorLabel, 3)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    onCancel()
  }

  return (
    <VmView className="p-4">
      {/* Section Header */}
      <VmView className="bg-blue-500 text-white text-2xl font-semibold p-4 rounded-t-2xl">
        {label}
      </VmView>

      {/* Section body */}
      <VmView className="p-4 flex-1 border-x-2 border-b-2 border-gray-200 rounded-b-2xl rounded-x-2xl">
        {fields.map(field => (
          <VmView key={field.name} className="mb-4">
            <label className="block text-gray-700 mb-1">
              {field.label}
              {field.required && ' *'}
            </label>
            {renderInput ? (
              renderInput(field, form[field.name], handleChange)
            ) : (
              <input
                type={field.type}
                name={field.name}
                value={form[field.name] || ''}
                onChange={handleChange}
                className="w-full p-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            )}
          </VmView>
        ))}
      </VmView>

      {/* Section Footer */}
      <VmView className="fixed bottom-0 left-0 w-full bg-white shadow-md p-4 flex justify-between">
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading}
          className={`success p-2 px-4 rounded-lg ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          Simpan
        </button>

        <button
          type="button"
          onClick={handleCancel}
          className="danger-outline p-2 px-4 rounded-lg"
        >
          Batal
        </button>
      </VmView>

      <ProgressFullScreen visible={loading} />
      <AlertForm {...{...propsalertform, noText: false, yesText: 'Ok'}} />
    </VmView>
  )
}
